import script from "./WageSummaryContent.vue?vue&type=script&setup=true&lang=js"
export * from "./WageSummaryContent.vue?vue&type=script&setup=true&lang=js"

import "./WageSummaryContent.vue?vue&type=style&index=0&id=172b3d0b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-172b3d0b"]])

export default __exports__